// @generated by protobuf-ts 2.9.0 with parameter generate_dependencies,force_optimize_code_size,long_type_string,ts_nocheck
// @generated from protobuf file "common/v1/common.proto" (package "viam.common.v1", syntax proto3)
// tslint:disable
// @ts-nocheck
import { MessageType } from "@protobuf-ts/runtime";
import { Value } from "../../google/protobuf/struct";
import { Timestamp } from "../../google/protobuf/timestamp";
import { Struct } from "../../google/protobuf/struct";
/**
 * @generated from protobuf message viam.common.v1.ResourceName
 */
export interface ResourceName {
    /**
     * @generated from protobuf field: string namespace = 1;
     */
    namespace: string;
    /**
     * @generated from protobuf field: string type = 2;
     */
    type: string;
    /**
     * @generated from protobuf field: string subtype = 3;
     */
    subtype: string;
    /**
     * @generated from protobuf field: string name = 4;
     */
    name: string;
}
/**
 * Pose is a combination of location and orientation.
 * Location is expressed as distance which is represented by x , y, z coordinates. Orientation is expressed as an orientation vector which
 * is represented by o_x, o_y, o_z and theta. The o_x, o_y, o_z coordinates represent the point on the cartesian unit sphere that the end of
 * the arm is pointing to (with the origin as reference). That unit vector forms an axis around which theta rotates. This means that
 * incrementing / decrementing theta will perform an inline rotation of the end effector.
 * Theta is defined as rotation between two planes: the first being defined by the origin, the point (0,0,1), and the rx, ry, rz point, and the
 * second being defined by the origin, the rx, ry, rz point and the local Z axis. Therefore, if theta is kept at zero as the north/south pole
 * is circled, the Roll will correct itself to remain in-line.
 *
 * @generated from protobuf message viam.common.v1.Pose
 */
export interface Pose {
    /**
     * millimeters from the origin
     *
     * @generated from protobuf field: double x = 1;
     */
    x: number;
    /**
     * millimeters from the origin
     *
     * @generated from protobuf field: double y = 2;
     */
    y: number;
    /**
     * millimeters from the origin
     *
     * @generated from protobuf field: double z = 3;
     */
    z: number;
    /**
     * z component of a vector defining axis of rotation
     *
     * @generated from protobuf field: double o_x = 4;
     */
    oX: number;
    /**
     * x component of a vector defining axis of rotation
     *
     * @generated from protobuf field: double o_y = 5;
     */
    oY: number;
    /**
     * y component of a vector defining axis of rotation
     *
     * @generated from protobuf field: double o_z = 6;
     */
    oZ: number;
    /**
     * degrees
     *
     * @generated from protobuf field: double theta = 7;
     */
    theta: number;
}
/**
 * @generated from protobuf message viam.common.v1.Orientation
 */
export interface Orientation {
    /**
     * x component of a vector defining axis of rotation
     *
     * @generated from protobuf field: double o_x = 1;
     */
    oX: number;
    /**
     * y component of a vector defining axis of rotation
     *
     * @generated from protobuf field: double o_y = 2;
     */
    oY: number;
    /**
     * z component of a vector defining axis of rotation
     *
     * @generated from protobuf field: double o_z = 3;
     */
    oZ: number;
    /**
     * degrees
     *
     * @generated from protobuf field: double theta = 4;
     */
    theta: number;
}
/**
 * @generated from protobuf message viam.common.v1.PoseCloud
 */
export interface PoseCloud {
    /**
     * @generated from protobuf field: double x = 1;
     */
    x: number;
    /**
     * @generated from protobuf field: double y = 2;
     */
    y: number;
    /**
     * @generated from protobuf field: double z = 3;
     */
    z: number;
    /**
     * @generated from protobuf field: double o_x = 4;
     */
    oX: number;
    /**
     * @generated from protobuf field: double o_y = 5;
     */
    oY: number;
    /**
     * @generated from protobuf field: double o_z = 6;
     */
    oZ: number;
    /**
     * @generated from protobuf field: double theta = 7;
     */
    theta: number;
}
/**
 * PoseInFrame contains a pose and the reference frame in which it was observed
 *
 * @generated from protobuf message viam.common.v1.PoseInFrame
 */
export interface PoseInFrame {
    /**
     * @generated from protobuf field: string reference_frame = 1;
     */
    referenceFrame: string;
    /**
     * @generated from protobuf field: viam.common.v1.Pose pose = 2;
     */
    pose?: Pose;
    /**
     * @generated from protobuf field: optional viam.common.v1.PoseCloud goal_cloud = 3;
     */
    goalCloud?: PoseCloud;
}
/**
 * @generated from protobuf message viam.common.v1.Vector3
 */
export interface Vector3 {
    /**
     * @generated from protobuf field: double x = 1;
     */
    x: number;
    /**
     * @generated from protobuf field: double y = 2;
     */
    y: number;
    /**
     * @generated from protobuf field: double z = 3;
     */
    z: number;
}
/**
 * @generated from protobuf message viam.common.v1.Sphere
 */
export interface Sphere {
    /**
     * @generated from protobuf field: double radius_mm = 1;
     */
    radiusMm: number;
}
/**
 * @generated from protobuf message viam.common.v1.Capsule
 */
export interface Capsule {
    /**
     * @generated from protobuf field: double radius_mm = 1;
     */
    radiusMm: number;
    /**
     * @generated from protobuf field: double length_mm = 2;
     */
    lengthMm: number;
}
/**
 * RectangularPrism contains a Vector3 field corresponding to the X, Y, Z dimensions of the prism in mms
 * These dimensions are with respect to the referenceframe in which the RectangularPrism is defined
 *
 * @generated from protobuf message viam.common.v1.RectangularPrism
 */
export interface RectangularPrism {
    /**
     * @generated from protobuf field: viam.common.v1.Vector3 dims_mm = 1;
     */
    dimsMm?: Vector3;
}
/**
 * @generated from protobuf message viam.common.v1.Mesh
 */
export interface Mesh {
    /**
     * Content type of mesh (e.g. ply)
     *
     * @generated from protobuf field: string content_type = 1;
     */
    contentType: string;
    /**
     * Contents of mesh data in binary form defined by content_type
     *
     * @generated from protobuf field: bytes mesh = 2;
     */
    mesh: Uint8Array;
    /**
     * Path the mesh was loaded from, relative to the kinematics file. Informational on the wire.
     *
     * @generated from protobuf field: optional string original_file_source_path_diagnostic = 3;
     */
    originalFileSourcePathDiagnostic?: string;
}
/**
 * @generated from protobuf message viam.common.v1.PointCloud
 */
export interface PointCloud {
    /**
     * @generated from protobuf field: bytes point_cloud = 1;
     */
    pointCloud: Uint8Array;
}
/**
 * Geometry contains the dimensions of a given geometry and the pose of its center. The geometry is one of either a sphere or a box.
 *
 * @generated from protobuf message viam.common.v1.Geometry
 */
export interface Geometry {
    /**
     * Pose of a geometries center point
     *
     * @generated from protobuf field: viam.common.v1.Pose center = 1;
     */
    center?: Pose;
    /**
     * @generated from protobuf oneof: geometry_type
     */
    geometryType: {
        oneofKind: "sphere";
        /**
         * @generated from protobuf field: viam.common.v1.Sphere sphere = 2;
         */
        sphere: Sphere;
    } | {
        oneofKind: "box";
        /**
         * @generated from protobuf field: viam.common.v1.RectangularPrism box = 3;
         */
        box: RectangularPrism;
    } | {
        oneofKind: "capsule";
        /**
         * @generated from protobuf field: viam.common.v1.Capsule capsule = 5;
         */
        capsule: Capsule;
    } | {
        oneofKind: "mesh";
        /**
         * @generated from protobuf field: viam.common.v1.Mesh mesh = 6;
         */
        mesh: Mesh;
    } | {
        oneofKind: "pointcloud";
        /**
         * @generated from protobuf field: viam.common.v1.PointCloud pointcloud = 7;
         */
        pointcloud: PointCloud;
    } | {
        oneofKind: undefined;
    };
    /**
     * Label of the geometry. If none supplied, will be an empty string.
     *
     * @generated from protobuf field: string label = 4;
     */
    label: string;
}
/**
 * GeometriesinFrame contains the dimensions of a given geometry, pose of its center point, and the reference frame by which it was
 * observed.
 *
 * @generated from protobuf message viam.common.v1.GeometriesInFrame
 */
export interface GeometriesInFrame {
    /**
     * Reference frame of the observer of the geometry
     *
     * @generated from protobuf field: string reference_frame = 1;
     */
    referenceFrame: string;
    /**
     * Dimensional type
     *
     * @generated from protobuf field: repeated viam.common.v1.Geometry geometries = 2;
     */
    geometries: Geometry[];
}
/**
 * PointCloudObject contains an image in bytes with point cloud data of all of the objects captured by a given observer as well as a
 * repeated list of geometries which respresents the center point and geometry of each of the objects within the point cloud
 *
 * @generated from protobuf message viam.common.v1.PointCloudObject
 */
export interface PointCloudObject {
    /**
     * image frame expressed in bytes
     *
     * @generated from protobuf field: bytes point_cloud = 1;
     */
    pointCloud: Uint8Array;
    /**
     * volume of a given geometry
     *
     * @generated from protobuf field: viam.common.v1.GeometriesInFrame geometries = 2;
     */
    geometries?: GeometriesInFrame;
}
/**
 * @generated from protobuf message viam.common.v1.GeoPoint
 */
export interface GeoPoint {
    /**
     * @generated from protobuf field: double latitude = 1;
     */
    latitude: number;
    /**
     * @generated from protobuf field: double longitude = 2;
     */
    longitude: number;
}
/**
 * GeoPose is a GPS position and orientation, optionally with altitude.
 *
 * Orientation is expressed in the east-north-up tangent frame at location:
 * +X east, +Y north, +Z up. Viam base axes are +X right, +Y forward, and +Z up,
 * so the identity orientation (o_x, o_y, o_z, theta) = (0, 0, 1, 0) is level and
 * faces north: forward is north and right is east.
 *
 * The same rotation as an orientation vector is Viam's Tait-Bryan Euler sequence,
 * intrinsic z-y'-x'' (yaw, then pitch, then roll), in degrees:
 *   - yaw: right-handed rotation about local up (+Z). Zero faces north. Positive
 *     yaw is counterclockwise viewed from above, so a compass heading in degrees
 *     clockwise from north is the negation of yaw.
 *   - pitch: right-handed rotation about the base's forward axis (+Y).
 *   - roll: right-handed rotation about the base's right axis (+X). With pitch 0,
 *     positive roll raises the forward axis; that angle is the elevation of
 *     forward above the local horizon.
 *
 * Exactly one of heading or orientation_vector is set. heading is only the
 * compass yaw of a level pose (pitch 0, roll 0). It is not added to
 * orientation_vector.
 *
 * @generated from protobuf message viam.common.v1.GeoPose
 */
export interface GeoPose {
    /**
     * Latitude and longitude in degrees
     *
     * @generated from protobuf field: viam.common.v1.GeoPoint location = 1;
     */
    location?: GeoPoint;
    /**
     * Optional altitude in meters
     *
     * @generated from protobuf field: optional double altitude = 3;
     */
    altitude?: number;
    /**
     * @generated from protobuf oneof: orientation
     */
    orientation: {
        oneofKind: "heading";
        /**
         * Compass heading in degrees, clockwise from north. Level pose: pitch 0, roll 0.
         *
         * @generated from protobuf field: double heading = 2;
         */
        heading: number;
    } | {
        oneofKind: "orientationVector";
        /**
         * Full orientation in the east-north-up tangent frame at location.
         * o_x, o_y, o_z, theta in degrees, same orientation vector as Pose.
         *
         * @generated from protobuf field: viam.common.v1.Orientation orientation_vector = 4;
         */
        orientationVector: Orientation;
    } | {
        oneofKind: undefined;
    };
}
/**
 * GeoGeometry contains information describing Geometry(s) that is located at a GeoPoint
 *
 * @generated from protobuf message viam.common.v1.GeoGeometry
 */
export interface GeoGeometry {
    /**
     * Location of the geometry
     *
     * @generated from protobuf field: viam.common.v1.GeoPoint location = 1;
     */
    location?: GeoPoint;
    /**
     * Geometries associated with the location, where embedded Pose data is with respect to the specified location
     *
     * @generated from protobuf field: repeated viam.common.v1.Geometry geometries = 2;
     */
    geometries: Geometry[];
}
/**
 * Transform contains a pose and two reference frames. The first reference frame is the starting reference frame, and the second reference
 * frame is the observer reference frame. The second reference frame has a pose which represents the pose of an object in the first
 * reference frame as observed within the second reference frame.
 *
 * @generated from protobuf message viam.common.v1.Transform
 */
export interface Transform {
    /**
     * the name of a given reference frame
     *
     * @generated from protobuf field: string reference_frame = 1;
     */
    referenceFrame: string;
    /**
     * the pose of the above reference frame with respect to a different observer reference frame
     *
     * @generated from protobuf field: viam.common.v1.PoseInFrame pose_in_observer_frame = 2;
     */
    poseInObserverFrame?: PoseInFrame;
    /**
     * @generated from protobuf field: optional viam.common.v1.Geometry physical_object = 3;
     */
    physicalObject?: Geometry;
    /**
     * The UUID of the transform
     *
     * @generated from protobuf field: bytes uuid = 4;
     */
    uuid: Uint8Array;
    /**
     * Can hold information like color, opacity, points colors, collision_allowed, etc...
     *
     * @generated from protobuf field: optional google.protobuf.Struct metadata = 5;
     */
    metadata?: Struct;
}
/**
 * WorldState contains information about the physical environment around a given robot. All of the fields within this message are optional,
 * they can include information about the physical dimensions of an obstacle, the freespace of a robot, and any desired transforms between a
 * given reference frame and a new target reference frame.
 *
 * @generated from protobuf message viam.common.v1.WorldState
 */
export interface WorldState {
    /**
     * a list of obstacles expressed as a geometry and the reference frame in which it was observed; this field is optional
     *
     * @generated from protobuf field: repeated viam.common.v1.GeometriesInFrame obstacles = 1;
     */
    obstacles: GeometriesInFrame[];
    /**
     * a list of Transforms, optionally with geometries. Used as supplemental transforms to transform a pose from one reference frame to
     * another, or to attach moving geometries to the frame system. This field is optional
     *
     * @generated from protobuf field: repeated viam.common.v1.Transform transforms = 3;
     */
    transforms: Transform[];
}
/**
 * ActuatorStatus is a generic status for resources that only need to return actuator status.
 *
 * @generated from protobuf message viam.common.v1.ActuatorStatus
 */
export interface ActuatorStatus {
    /**
     * @generated from protobuf field: bool is_moving = 1;
     */
    isMoving: boolean;
}
/**
 * @generated from protobuf message viam.common.v1.ResponseMetadata
 */
export interface ResponseMetadata {
    /**
     * captured_at is the time at which the resource as close as physically possible, captured
     * the data in the response.
     * Note: If correlating between other resources, be sure that the means
     * of measuring the capture are similar enough such that comparison can be made between them.
     *
     * @generated from protobuf field: optional google.protobuf.Timestamp captured_at = 1;
     */
    capturedAt?: Timestamp;
}
/**
 * DoCommandRequest represents a generic DoCommand input
 *
 * @generated from protobuf message viam.common.v1.DoCommandRequest
 */
export interface DoCommandRequest {
    /**
     * @generated from protobuf field: string name = 1;
     */
    name: string;
    /**
     * @generated from protobuf field: google.protobuf.Struct command = 2;
     */
    command?: Struct;
}
/**
 * DoCommandResponse represents a generic DoCommand output
 *
 * @generated from protobuf message viam.common.v1.DoCommandResponse
 */
export interface DoCommandResponse {
    /**
     * @generated from protobuf field: google.protobuf.Struct result = 1;
     */
    result?: Struct;
}
/**
 * GetStatusRequest represents a generic GetStatus input
 *
 * @generated from protobuf message viam.common.v1.GetStatusRequest
 */
export interface GetStatusRequest {
    /**
     * @generated from protobuf field: string name = 1;
     */
    name: string;
}
/**
 * GetStatusResponse represents a generic GetStatus output
 *
 * @generated from protobuf message viam.common.v1.GetStatusResponse
 */
export interface GetStatusResponse {
    /**
     * @generated from protobuf field: google.protobuf.Struct result = 1;
     */
    result?: Struct;
}
/**
 * @generated from protobuf message viam.common.v1.GetKinematicsRequest
 */
export interface GetKinematicsRequest {
    /**
     * The component name
     *
     * @generated from protobuf field: string name = 1;
     */
    name: string;
    /**
     * Include collision mesh bytes in the response. Otherwise meshes carry only their path.
     *
     * @generated from protobuf field: bool include_collision_meshes = 2;
     */
    includeCollisionMeshes: boolean;
    /**
     * Include visual mesh bytes in the response
     *
     * @generated from protobuf field: bool include_visual_meshes = 3;
     */
    includeVisualMeshes: boolean;
    /**
     * Additional arguments to the method
     *
     * @generated from protobuf field: google.protobuf.Struct extra = 99;
     */
    extra?: Struct;
}
/**
 * @generated from protobuf message viam.common.v1.GetKinematicsResponse
 */
export interface GetKinematicsResponse {
    /**
     * Deprecated: use model. The kinematics of the component, in either URDF format or in Viam’s kinematic parameter format (spatial vector algebra)
     * https://docs.viam.com/internals/kinematic-chain-config/#kinematic-parameters
     *
     * @deprecated
     * @generated from protobuf field: viam.common.v1.KinematicsFileFormat format = 1 [deprecated = true];
     */
    format: KinematicsFileFormat;
    /**
     * Deprecated: use model. The byte contents of the file
     *
     * @deprecated
     * @generated from protobuf field: bytes kinematics_data = 2 [deprecated = true];
     */
    kinematicsData: Uint8Array;
    /**
     * Deprecated: use model. Map of URDF mesh file paths to mesh data
     *
     * @deprecated
     * @generated from protobuf field: map<string, viam.common.v1.Mesh> meshes_by_urdf_filepath = 3 [deprecated = true];
     */
    meshesByUrdfFilepath: {
        [key: string]: Mesh;
    };
    /**
     * The kinematic model of the component
     *
     * @generated from protobuf field: viam.common.v1.KinematicModel model = 4;
     */
    model?: KinematicModel;
}
/**
 * KinematicModel describes a component's kinematics as a tree of links and joints.
 * Its proto JSON encoding is also the on-disk kinematics file format.
 *
 * @generated from protobuf message viam.common.v1.KinematicModel
 */
export interface KinematicModel {
    /**
     * Set to the resource name by the SDK when served
     *
     * @generated from protobuf field: string name = 1;
     */
    name: string;
    /**
     * @generated from protobuf field: repeated viam.common.v1.KinematicLink links = 2;
     */
    links: KinematicLink[];
    /**
     * @generated from protobuf field: repeated viam.common.v1.KinematicJoint joints = 3;
     */
    joints: KinematicJoint[];
    /**
     * Frames whose poses the model reports
     *
     * @generated from protobuf field: repeated string output_frames = 4;
     */
    outputFrames: string[];
    /**
     * @generated from protobuf field: viam.common.v1.KinematicProperties properties = 5;
     */
    properties?: KinematicProperties;
}
/**
 * @generated from protobuf message viam.common.v1.KinematicLink
 */
export interface KinematicLink {
    /**
     * @generated from protobuf field: string id = 1;
     */
    id: string;
    /**
     * Parent link or joint id, empty for the root
     *
     * @generated from protobuf field: string parent = 2;
     */
    parent: string;
    /**
     * Pose relative to the parent
     *
     * @generated from protobuf field: viam.common.v1.LinkPose pose = 3;
     */
    pose?: LinkPose;
    /**
     * Collision geometries, meshes must be stl or ply
     *
     * @generated from protobuf field: repeated viam.common.v1.Geometry collision = 4;
     */
    collision: Geometry[];
    /**
     * Display geometries, not used for collision checking
     *
     * @generated from protobuf field: repeated viam.common.v1.Geometry visual = 5;
     */
    visual: Geometry[];
}
/**
 * LinkPose is a translation in mm and an orientation in degrees, identity when absent
 *
 * @generated from protobuf message viam.common.v1.LinkPose
 */
export interface LinkPose {
    /**
     * @generated from protobuf field: viam.common.v1.Vector3 translation = 1;
     */
    translation?: Vector3;
    /**
     * @generated from protobuf oneof: orientation
     */
    orientation: {
        oneofKind: "quaternion";
        /**
         * @generated from protobuf field: viam.common.v1.Quaternion quaternion = 2;
         */
        quaternion: Quaternion;
    } | {
        oneofKind: "orientationVector";
        /**
         * theta in degrees
         *
         * @generated from protobuf field: viam.common.v1.Orientation orientation_vector = 3;
         */
        orientationVector: Orientation;
    } | {
        oneofKind: "eulerAngles";
        /**
         * @generated from protobuf field: viam.common.v1.EulerAngles euler_angles = 4;
         */
        eulerAngles: EulerAngles;
    } | {
        oneofKind: "axisAngles";
        /**
         * @generated from protobuf field: viam.common.v1.AxisAngles axis_angles = 5;
         */
        axisAngles: AxisAngles;
    } | {
        oneofKind: undefined;
    };
}
/**
 * @generated from protobuf message viam.common.v1.Quaternion
 */
export interface Quaternion {
    /**
     * @generated from protobuf field: double w = 1;
     */
    w: number;
    /**
     * @generated from protobuf field: double x = 2;
     */
    x: number;
    /**
     * @generated from protobuf field: double y = 3;
     */
    y: number;
    /**
     * @generated from protobuf field: double z = 4;
     */
    z: number;
}
/**
 * Euler angles in degrees
 *
 * @generated from protobuf message viam.common.v1.EulerAngles
 */
export interface EulerAngles {
    /**
     * @generated from protobuf field: double roll = 1;
     */
    roll: number;
    /**
     * @generated from protobuf field: double pitch = 2;
     */
    pitch: number;
    /**
     * @generated from protobuf field: double yaw = 3;
     */
    yaw: number;
}
/**
 * Rotation axis and an angle theta in degrees
 *
 * @generated from protobuf message viam.common.v1.AxisAngles
 */
export interface AxisAngles {
    /**
     * @generated from protobuf field: double rx = 1;
     */
    rx: number;
    /**
     * @generated from protobuf field: double ry = 2;
     */
    ry: number;
    /**
     * @generated from protobuf field: double rz = 3;
     */
    rz: number;
    /**
     * @generated from protobuf field: double theta = 4;
     */
    theta: number;
}
/**
 * @generated from protobuf message viam.common.v1.KinematicJoint
 */
export interface KinematicJoint {
    /**
     * @generated from protobuf field: string id = 1;
     */
    id: string;
    /**
     * Parent link id
     *
     * @generated from protobuf field: string parent = 2;
     */
    parent: string;
    /**
     * @generated from protobuf field: viam.common.v1.JointType type = 3;
     */
    type: JointType;
    /**
     * @generated from protobuf field: viam.common.v1.Vector3 axis = 4;
     */
    axis?: Vector3;
    /**
     * Effective limits the component serves
     *
     * @generated from protobuf field: viam.common.v1.JointLimits limits = 5;
     */
    limits?: JointLimits;
    /**
     * @generated from protobuf field: viam.common.v1.MimicJoint mimic = 6;
     */
    mimic?: MimicJoint;
    /**
     * Only meaningful for prismatic joints
     *
     * @generated from protobuf field: viam.common.v1.Geometry geometry = 7;
     */
    geometry?: Geometry;
}
/**
 * Degrees, deg/s and deg/s^2 for revolute joints, mm, mm/s and mm/s^2 for prismatic. Absent means unbounded.
 *
 * @generated from protobuf message viam.common.v1.JointLimits
 */
export interface JointLimits {
    /**
     * @generated from protobuf field: optional double min = 1;
     */
    min?: number;
    /**
     * @generated from protobuf field: optional double max = 2;
     */
    max?: number;
    /**
     * @generated from protobuf field: optional double max_velocity = 3;
     */
    maxVelocity?: number;
    /**
     * @generated from protobuf field: optional double max_acceleration = 4;
     */
    maxAcceleration?: number;
}
/**
 * Position is multiplier * position of joint + offset
 *
 * @generated from protobuf message viam.common.v1.MimicJoint
 */
export interface MimicJoint {
    /**
     * @generated from protobuf field: string joint = 1;
     */
    joint: string;
    /**
     * @generated from protobuf field: double multiplier = 2;
     */
    multiplier: number;
    /**
     * @generated from protobuf field: double offset = 3;
     */
    offset: number;
}
/**
 * Properties of the component as a whole
 *
 * @generated from protobuf message viam.common.v1.KinematicProperties
 */
export interface KinematicProperties {
    /**
     * Rate the component expects to be driven at
     *
     * @generated from protobuf field: optional double operating_freq_hz = 1;
     */
    operatingFreqHz?: number;
    /**
     * Maximum linear speed of the tool center point
     *
     * @generated from protobuf field: optional double max_linear_tcp_speed_mm_per_sec = 2;
     */
    maxLinearTcpSpeedMmPerSec?: number;
}
/**
 * @generated from protobuf message viam.common.v1.GetGeometriesRequest
 */
export interface GetGeometriesRequest {
    /**
     * The component name
     *
     * @generated from protobuf field: string name = 1;
     */
    name: string;
    /**
     * Additional arguments to the method
     *
     * @generated from protobuf field: google.protobuf.Struct extra = 99;
     */
    extra?: Struct;
}
/**
 * @generated from protobuf message viam.common.v1.GetGeometriesResponse
 */
export interface GetGeometriesResponse {
    /**
     * All geometries associated with the component, in their current configuration, in the frame of that component.
     *
     * @generated from protobuf field: repeated viam.common.v1.Geometry geometries = 1;
     */
    geometries: Geometry[];
}
/**
 * @generated from protobuf message viam.common.v1.Get3DModelsRequest
 */
export interface Get3DModelsRequest {
    /**
     * The component name
     *
     * @generated from protobuf field: string name = 1;
     */
    name: string;
    /**
     * Additional arguments to the method
     *
     * @generated from protobuf field: google.protobuf.Struct extra = 99;
     */
    extra?: Struct;
}
/**
 * @generated from protobuf message viam.common.v1.Get3DModelsResponse
 */
export interface Get3DModelsResponse {
    /**
     * the 3D models associated with the component
     *
     * @generated from protobuf field: map<string, viam.common.v1.Mesh> models = 1;
     */
    models: {
        [key: string]: Mesh;
    };
}
/**
 * @generated from protobuf message viam.common.v1.GetWorldPoseResponse
 */
export interface GetWorldPoseResponse {
    /**
     * Pose of the component in the world reference frame
     *
     * @generated from protobuf field: viam.common.v1.Pose pose = 1;
     */
    pose?: Pose;
}
/**
 * @generated from protobuf message viam.common.v1.GetReadingsRequest
 */
export interface GetReadingsRequest {
    /**
     * Name of a sensor
     *
     * @generated from protobuf field: string name = 1;
     */
    name: string;
    /**
     * Additional arguments to the method
     *
     * @generated from protobuf field: google.protobuf.Struct extra = 99;
     */
    extra?: Struct;
}
/**
 * @generated from protobuf message viam.common.v1.GetReadingsResponse
 */
export interface GetReadingsResponse {
    /**
     * @generated from protobuf field: map<string, google.protobuf.Value> readings = 1;
     */
    readings: {
        [key: string]: Value;
    };
}
/**
 * @generated from protobuf message viam.common.v1.LogEntry
 */
export interface LogEntry {
    /**
     * @generated from protobuf field: string host = 1;
     */
    host: string;
    /**
     * @generated from protobuf field: string level = 2;
     */
    level: string;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp time = 3;
     */
    time?: Timestamp;
    /**
     * @generated from protobuf field: string logger_name = 4;
     */
    loggerName: string;
    /**
     * @generated from protobuf field: string message = 5;
     */
    message: string;
    /**
     * @generated from protobuf field: google.protobuf.Struct caller = 6;
     */
    caller?: Struct;
    /**
     * @generated from protobuf field: string stack = 7;
     */
    stack: string;
    /**
     * @generated from protobuf field: repeated google.protobuf.Struct fields = 8;
     */
    fields: Struct[];
}
/**
 * Information about an audio stream or device.
 *
 * @generated from protobuf message viam.common.v1.AudioInfo
 */
export interface AudioInfo {
    /**
     * Audio codec used for the stream or device (e.g., "pcm16", "pcm32float", "mp3")
     *
     * @generated from protobuf field: string codec = 1;
     */
    codec: string;
    /**
     * Sample rate of the audio in Hz
     *
     * @generated from protobuf field: int32 sample_rate_hz = 2;
     */
    sampleRateHz: number;
    /**
     * Number of audio channels in the recording or playback
     *
     * @generated from protobuf field: int32 num_channels = 3;
     */
    numChannels: number;
}
/**
 * Shared properties for AudioIn and AudioOut components.
 *
 * @generated from protobuf message viam.common.v1.GetPropertiesRequest
 */
export interface GetPropertiesRequest {
    /**
     * @generated from protobuf field: string name = 1;
     */
    name: string;
    /**
     * @generated from protobuf field: google.protobuf.Struct extra = 99;
     */
    extra?: Struct;
}
/**
 * @generated from protobuf message viam.common.v1.GetPropertiesResponse
 */
export interface GetPropertiesResponse {
    /**
     * List of audio codecs supported by the system (e.g., "mp3", "pcm16", "pcm32float")
     *
     * @generated from protobuf field: repeated string supported_codecs = 1;
     */
    supportedCodecs: string[];
    /**
     * current sample rate in Hz
     *
     * @generated from protobuf field: int32 sample_rate_hz = 2;
     */
    sampleRateHz: number;
    /**
     * Maximum number of audio channels supported (e.g., 1 for mono, 2 for stereo)
     *
     * @generated from protobuf field: int32 num_channels = 3;
     */
    numChannels: number;
}
/**
 * @generated from protobuf enum viam.common.v1.KinematicsFileFormat
 */
export enum KinematicsFileFormat {
    /**
     * @generated from protobuf enum value: KINEMATICS_FILE_FORMAT_UNSPECIFIED = 0;
     */
    UNSPECIFIED = 0,
    /**
     * @generated from protobuf enum value: KINEMATICS_FILE_FORMAT_SVA = 1;
     */
    SVA = 1,
    /**
     * @generated from protobuf enum value: KINEMATICS_FILE_FORMAT_URDF = 2;
     */
    URDF = 2
}
/**
 * @generated from protobuf enum viam.common.v1.JointType
 */
export enum JointType {
    /**
     * @generated from protobuf enum value: JOINT_TYPE_UNSPECIFIED = 0;
     */
    UNSPECIFIED = 0,
    /**
     * @generated from protobuf enum value: JOINT_TYPE_REVOLUTE = 1;
     */
    REVOLUTE = 1,
    /**
     * @generated from protobuf enum value: JOINT_TYPE_PRISMATIC = 2;
     */
    PRISMATIC = 2,
    /**
     * Revolute joint with no position bound
     *
     * @generated from protobuf enum value: JOINT_TYPE_CONTINUOUS = 3;
     */
    CONTINUOUS = 3
}
// @generated message type with reflection information, may provide speed optimized methods
class ResourceName$Type extends MessageType<ResourceName> {
    constructor() {
        super("viam.common.v1.ResourceName", [
            { no: 1, name: "namespace", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "type", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "subtype", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "name", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message viam.common.v1.ResourceName
 */
export const ResourceName = new ResourceName$Type();
// @generated message type with reflection information, may provide speed optimized methods
class Pose$Type extends MessageType<Pose> {
    constructor() {
        super("viam.common.v1.Pose", [
            { no: 1, name: "x", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ },
            { no: 2, name: "y", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ },
            { no: 3, name: "z", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ },
            { no: 4, name: "o_x", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ },
            { no: 5, name: "o_y", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ },
            { no: 6, name: "o_z", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ },
            { no: 7, name: "theta", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message viam.common.v1.Pose
 */
export const Pose = new Pose$Type();
// @generated message type with reflection information, may provide speed optimized methods
class Orientation$Type extends MessageType<Orientation> {
    constructor() {
        super("viam.common.v1.Orientation", [
            { no: 1, name: "o_x", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ },
            { no: 2, name: "o_y", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ },
            { no: 3, name: "o_z", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ },
            { no: 4, name: "theta", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message viam.common.v1.Orientation
 */
export const Orientation = new Orientation$Type();
// @generated message type with reflection information, may provide speed optimized methods
class PoseCloud$Type extends MessageType<PoseCloud> {
    constructor() {
        super("viam.common.v1.PoseCloud", [
            { no: 1, name: "x", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ },
            { no: 2, name: "y", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ },
            { no: 3, name: "z", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ },
            { no: 4, name: "o_x", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ },
            { no: 5, name: "o_y", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ },
            { no: 6, name: "o_z", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ },
            { no: 7, name: "theta", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message viam.common.v1.PoseCloud
 */
export const PoseCloud = new PoseCloud$Type();
// @generated message type with reflection information, may provide speed optimized methods
class PoseInFrame$Type extends MessageType<PoseInFrame> {
    constructor() {
        super("viam.common.v1.PoseInFrame", [
            { no: 1, name: "reference_frame", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "pose", kind: "message", T: () => Pose },
            { no: 3, name: "goal_cloud", kind: "message", T: () => PoseCloud }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message viam.common.v1.PoseInFrame
 */
export const PoseInFrame = new PoseInFrame$Type();
// @generated message type with reflection information, may provide speed optimized methods
class Vector3$Type extends MessageType<Vector3> {
    constructor() {
        super("viam.common.v1.Vector3", [
            { no: 1, name: "x", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ },
            { no: 2, name: "y", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ },
            { no: 3, name: "z", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message viam.common.v1.Vector3
 */
export const Vector3 = new Vector3$Type();
// @generated message type with reflection information, may provide speed optimized methods
class Sphere$Type extends MessageType<Sphere> {
    constructor() {
        super("viam.common.v1.Sphere", [
            { no: 1, name: "radius_mm", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message viam.common.v1.Sphere
 */
export const Sphere = new Sphere$Type();
// @generated message type with reflection information, may provide speed optimized methods
class Capsule$Type extends MessageType<Capsule> {
    constructor() {
        super("viam.common.v1.Capsule", [
            { no: 1, name: "radius_mm", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ },
            { no: 2, name: "length_mm", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message viam.common.v1.Capsule
 */
export const Capsule = new Capsule$Type();
// @generated message type with reflection information, may provide speed optimized methods
class RectangularPrism$Type extends MessageType<RectangularPrism> {
    constructor() {
        super("viam.common.v1.RectangularPrism", [
            { no: 1, name: "dims_mm", kind: "message", T: () => Vector3 }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message viam.common.v1.RectangularPrism
 */
export const RectangularPrism = new RectangularPrism$Type();
// @generated message type with reflection information, may provide speed optimized methods
class Mesh$Type extends MessageType<Mesh> {
    constructor() {
        super("viam.common.v1.Mesh", [
            { no: 1, name: "content_type", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "mesh", kind: "scalar", T: 12 /*ScalarType.BYTES*/ },
            { no: 3, name: "original_file_source_path_diagnostic", kind: "scalar", opt: true, T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message viam.common.v1.Mesh
 */
export const Mesh = new Mesh$Type();
// @generated message type with reflection information, may provide speed optimized methods
class PointCloud$Type extends MessageType<PointCloud> {
    constructor() {
        super("viam.common.v1.PointCloud", [
            { no: 1, name: "point_cloud", kind: "scalar", T: 12 /*ScalarType.BYTES*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message viam.common.v1.PointCloud
 */
export const PointCloud = new PointCloud$Type();
// @generated message type with reflection information, may provide speed optimized methods
class Geometry$Type extends MessageType<Geometry> {
    constructor() {
        super("viam.common.v1.Geometry", [
            { no: 1, name: "center", kind: "message", T: () => Pose },
            { no: 2, name: "sphere", kind: "message", oneof: "geometryType", T: () => Sphere },
            { no: 3, name: "box", kind: "message", oneof: "geometryType", T: () => RectangularPrism },
            { no: 5, name: "capsule", kind: "message", oneof: "geometryType", T: () => Capsule },
            { no: 6, name: "mesh", kind: "message", oneof: "geometryType", T: () => Mesh },
            { no: 7, name: "pointcloud", kind: "message", oneof: "geometryType", T: () => PointCloud },
            { no: 4, name: "label", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message viam.common.v1.Geometry
 */
export const Geometry = new Geometry$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GeometriesInFrame$Type extends MessageType<GeometriesInFrame> {
    constructor() {
        super("viam.common.v1.GeometriesInFrame", [
            { no: 1, name: "reference_frame", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "geometries", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => Geometry }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message viam.common.v1.GeometriesInFrame
 */
export const GeometriesInFrame = new GeometriesInFrame$Type();
// @generated message type with reflection information, may provide speed optimized methods
class PointCloudObject$Type extends MessageType<PointCloudObject> {
    constructor() {
        super("viam.common.v1.PointCloudObject", [
            { no: 1, name: "point_cloud", kind: "scalar", T: 12 /*ScalarType.BYTES*/ },
            { no: 2, name: "geometries", kind: "message", T: () => GeometriesInFrame }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message viam.common.v1.PointCloudObject
 */
export const PointCloudObject = new PointCloudObject$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GeoPoint$Type extends MessageType<GeoPoint> {
    constructor() {
        super("viam.common.v1.GeoPoint", [
            { no: 1, name: "latitude", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ },
            { no: 2, name: "longitude", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message viam.common.v1.GeoPoint
 */
export const GeoPoint = new GeoPoint$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GeoPose$Type extends MessageType<GeoPose> {
    constructor() {
        super("viam.common.v1.GeoPose", [
            { no: 1, name: "location", kind: "message", T: () => GeoPoint },
            { no: 3, name: "altitude", kind: "scalar", opt: true, T: 1 /*ScalarType.DOUBLE*/ },
            { no: 2, name: "heading", kind: "scalar", oneof: "orientation", T: 1 /*ScalarType.DOUBLE*/ },
            { no: 4, name: "orientation_vector", kind: "message", oneof: "orientation", T: () => Orientation }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message viam.common.v1.GeoPose
 */
export const GeoPose = new GeoPose$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GeoGeometry$Type extends MessageType<GeoGeometry> {
    constructor() {
        super("viam.common.v1.GeoGeometry", [
            { no: 1, name: "location", kind: "message", T: () => GeoPoint },
            { no: 2, name: "geometries", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => Geometry }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message viam.common.v1.GeoGeometry
 */
export const GeoGeometry = new GeoGeometry$Type();
// @generated message type with reflection information, may provide speed optimized methods
class Transform$Type extends MessageType<Transform> {
    constructor() {
        super("viam.common.v1.Transform", [
            { no: 1, name: "reference_frame", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "pose_in_observer_frame", kind: "message", T: () => PoseInFrame },
            { no: 3, name: "physical_object", kind: "message", T: () => Geometry },
            { no: 4, name: "uuid", kind: "scalar", T: 12 /*ScalarType.BYTES*/ },
            { no: 5, name: "metadata", kind: "message", T: () => Struct }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message viam.common.v1.Transform
 */
export const Transform = new Transform$Type();
// @generated message type with reflection information, may provide speed optimized methods
class WorldState$Type extends MessageType<WorldState> {
    constructor() {
        super("viam.common.v1.WorldState", [
            { no: 1, name: "obstacles", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => GeometriesInFrame },
            { no: 3, name: "transforms", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => Transform }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message viam.common.v1.WorldState
 */
export const WorldState = new WorldState$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ActuatorStatus$Type extends MessageType<ActuatorStatus> {
    constructor() {
        super("viam.common.v1.ActuatorStatus", [
            { no: 1, name: "is_moving", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message viam.common.v1.ActuatorStatus
 */
export const ActuatorStatus = new ActuatorStatus$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ResponseMetadata$Type extends MessageType<ResponseMetadata> {
    constructor() {
        super("viam.common.v1.ResponseMetadata", [
            { no: 1, name: "captured_at", kind: "message", T: () => Timestamp }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message viam.common.v1.ResponseMetadata
 */
export const ResponseMetadata = new ResponseMetadata$Type();
// @generated message type with reflection information, may provide speed optimized methods
class DoCommandRequest$Type extends MessageType<DoCommandRequest> {
    constructor() {
        super("viam.common.v1.DoCommandRequest", [
            { no: 1, name: "name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "command", kind: "message", T: () => Struct }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message viam.common.v1.DoCommandRequest
 */
export const DoCommandRequest = new DoCommandRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class DoCommandResponse$Type extends MessageType<DoCommandResponse> {
    constructor() {
        super("viam.common.v1.DoCommandResponse", [
            { no: 1, name: "result", kind: "message", T: () => Struct }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message viam.common.v1.DoCommandResponse
 */
export const DoCommandResponse = new DoCommandResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetStatusRequest$Type extends MessageType<GetStatusRequest> {
    constructor() {
        super("viam.common.v1.GetStatusRequest", [
            { no: 1, name: "name", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message viam.common.v1.GetStatusRequest
 */
export const GetStatusRequest = new GetStatusRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetStatusResponse$Type extends MessageType<GetStatusResponse> {
    constructor() {
        super("viam.common.v1.GetStatusResponse", [
            { no: 1, name: "result", kind: "message", T: () => Struct }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message viam.common.v1.GetStatusResponse
 */
export const GetStatusResponse = new GetStatusResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetKinematicsRequest$Type extends MessageType<GetKinematicsRequest> {
    constructor() {
        super("viam.common.v1.GetKinematicsRequest", [
            { no: 1, name: "name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "include_collision_meshes", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 3, name: "include_visual_meshes", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 99, name: "extra", kind: "message", T: () => Struct }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message viam.common.v1.GetKinematicsRequest
 */
export const GetKinematicsRequest = new GetKinematicsRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetKinematicsResponse$Type extends MessageType<GetKinematicsResponse> {
    constructor() {
        super("viam.common.v1.GetKinematicsResponse", [
            { no: 1, name: "format", kind: "enum", T: () => ["viam.common.v1.KinematicsFileFormat", KinematicsFileFormat, "KINEMATICS_FILE_FORMAT_"] },
            { no: 2, name: "kinematics_data", kind: "scalar", T: 12 /*ScalarType.BYTES*/ },
            { no: 3, name: "meshes_by_urdf_filepath", kind: "map", K: 9 /*ScalarType.STRING*/, V: { kind: "message", T: () => Mesh } },
            { no: 4, name: "model", kind: "message", T: () => KinematicModel }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message viam.common.v1.GetKinematicsResponse
 */
export const GetKinematicsResponse = new GetKinematicsResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class KinematicModel$Type extends MessageType<KinematicModel> {
    constructor() {
        super("viam.common.v1.KinematicModel", [
            { no: 1, name: "name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "links", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => KinematicLink },
            { no: 3, name: "joints", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => KinematicJoint },
            { no: 4, name: "output_frames", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/ },
            { no: 5, name: "properties", kind: "message", T: () => KinematicProperties }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message viam.common.v1.KinematicModel
 */
export const KinematicModel = new KinematicModel$Type();
// @generated message type with reflection information, may provide speed optimized methods
class KinematicLink$Type extends MessageType<KinematicLink> {
    constructor() {
        super("viam.common.v1.KinematicLink", [
            { no: 1, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "parent", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "pose", kind: "message", T: () => LinkPose },
            { no: 4, name: "collision", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => Geometry },
            { no: 5, name: "visual", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => Geometry }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message viam.common.v1.KinematicLink
 */
export const KinematicLink = new KinematicLink$Type();
// @generated message type with reflection information, may provide speed optimized methods
class LinkPose$Type extends MessageType<LinkPose> {
    constructor() {
        super("viam.common.v1.LinkPose", [
            { no: 1, name: "translation", kind: "message", T: () => Vector3 },
            { no: 2, name: "quaternion", kind: "message", oneof: "orientation", T: () => Quaternion },
            { no: 3, name: "orientation_vector", kind: "message", oneof: "orientation", T: () => Orientation },
            { no: 4, name: "euler_angles", kind: "message", oneof: "orientation", T: () => EulerAngles },
            { no: 5, name: "axis_angles", kind: "message", oneof: "orientation", T: () => AxisAngles }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message viam.common.v1.LinkPose
 */
export const LinkPose = new LinkPose$Type();
// @generated message type with reflection information, may provide speed optimized methods
class Quaternion$Type extends MessageType<Quaternion> {
    constructor() {
        super("viam.common.v1.Quaternion", [
            { no: 1, name: "w", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ },
            { no: 2, name: "x", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ },
            { no: 3, name: "y", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ },
            { no: 4, name: "z", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message viam.common.v1.Quaternion
 */
export const Quaternion = new Quaternion$Type();
// @generated message type with reflection information, may provide speed optimized methods
class EulerAngles$Type extends MessageType<EulerAngles> {
    constructor() {
        super("viam.common.v1.EulerAngles", [
            { no: 1, name: "roll", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ },
            { no: 2, name: "pitch", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ },
            { no: 3, name: "yaw", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message viam.common.v1.EulerAngles
 */
export const EulerAngles = new EulerAngles$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AxisAngles$Type extends MessageType<AxisAngles> {
    constructor() {
        super("viam.common.v1.AxisAngles", [
            { no: 1, name: "rx", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ },
            { no: 2, name: "ry", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ },
            { no: 3, name: "rz", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ },
            { no: 4, name: "theta", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message viam.common.v1.AxisAngles
 */
export const AxisAngles = new AxisAngles$Type();
// @generated message type with reflection information, may provide speed optimized methods
class KinematicJoint$Type extends MessageType<KinematicJoint> {
    constructor() {
        super("viam.common.v1.KinematicJoint", [
            { no: 1, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "parent", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "type", kind: "enum", T: () => ["viam.common.v1.JointType", JointType, "JOINT_TYPE_"] },
            { no: 4, name: "axis", kind: "message", T: () => Vector3 },
            { no: 5, name: "limits", kind: "message", T: () => JointLimits },
            { no: 6, name: "mimic", kind: "message", T: () => MimicJoint },
            { no: 7, name: "geometry", kind: "message", T: () => Geometry }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message viam.common.v1.KinematicJoint
 */
export const KinematicJoint = new KinematicJoint$Type();
// @generated message type with reflection information, may provide speed optimized methods
class JointLimits$Type extends MessageType<JointLimits> {
    constructor() {
        super("viam.common.v1.JointLimits", [
            { no: 1, name: "min", kind: "scalar", opt: true, T: 1 /*ScalarType.DOUBLE*/ },
            { no: 2, name: "max", kind: "scalar", opt: true, T: 1 /*ScalarType.DOUBLE*/ },
            { no: 3, name: "max_velocity", kind: "scalar", opt: true, T: 1 /*ScalarType.DOUBLE*/ },
            { no: 4, name: "max_acceleration", kind: "scalar", opt: true, T: 1 /*ScalarType.DOUBLE*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message viam.common.v1.JointLimits
 */
export const JointLimits = new JointLimits$Type();
// @generated message type with reflection information, may provide speed optimized methods
class MimicJoint$Type extends MessageType<MimicJoint> {
    constructor() {
        super("viam.common.v1.MimicJoint", [
            { no: 1, name: "joint", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "multiplier", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ },
            { no: 3, name: "offset", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message viam.common.v1.MimicJoint
 */
export const MimicJoint = new MimicJoint$Type();
// @generated message type with reflection information, may provide speed optimized methods
class KinematicProperties$Type extends MessageType<KinematicProperties> {
    constructor() {
        super("viam.common.v1.KinematicProperties", [
            { no: 1, name: "operating_freq_hz", kind: "scalar", opt: true, T: 1 /*ScalarType.DOUBLE*/ },
            { no: 2, name: "max_linear_tcp_speed_mm_per_sec", kind: "scalar", opt: true, T: 1 /*ScalarType.DOUBLE*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message viam.common.v1.KinematicProperties
 */
export const KinematicProperties = new KinematicProperties$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetGeometriesRequest$Type extends MessageType<GetGeometriesRequest> {
    constructor() {
        super("viam.common.v1.GetGeometriesRequest", [
            { no: 1, name: "name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 99, name: "extra", kind: "message", T: () => Struct }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message viam.common.v1.GetGeometriesRequest
 */
export const GetGeometriesRequest = new GetGeometriesRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetGeometriesResponse$Type extends MessageType<GetGeometriesResponse> {
    constructor() {
        super("viam.common.v1.GetGeometriesResponse", [
            { no: 1, name: "geometries", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => Geometry }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message viam.common.v1.GetGeometriesResponse
 */
export const GetGeometriesResponse = new GetGeometriesResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class Get3DModelsRequest$Type extends MessageType<Get3DModelsRequest> {
    constructor() {
        super("viam.common.v1.Get3DModelsRequest", [
            { no: 1, name: "name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 99, name: "extra", kind: "message", T: () => Struct }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message viam.common.v1.Get3DModelsRequest
 */
export const Get3DModelsRequest = new Get3DModelsRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class Get3DModelsResponse$Type extends MessageType<Get3DModelsResponse> {
    constructor() {
        super("viam.common.v1.Get3DModelsResponse", [
            { no: 1, name: "models", kind: "map", K: 9 /*ScalarType.STRING*/, V: { kind: "message", T: () => Mesh } }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message viam.common.v1.Get3DModelsResponse
 */
export const Get3DModelsResponse = new Get3DModelsResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetWorldPoseResponse$Type extends MessageType<GetWorldPoseResponse> {
    constructor() {
        super("viam.common.v1.GetWorldPoseResponse", [
            { no: 1, name: "pose", kind: "message", T: () => Pose }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message viam.common.v1.GetWorldPoseResponse
 */
export const GetWorldPoseResponse = new GetWorldPoseResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetReadingsRequest$Type extends MessageType<GetReadingsRequest> {
    constructor() {
        super("viam.common.v1.GetReadingsRequest", [
            { no: 1, name: "name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 99, name: "extra", kind: "message", T: () => Struct }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message viam.common.v1.GetReadingsRequest
 */
export const GetReadingsRequest = new GetReadingsRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetReadingsResponse$Type extends MessageType<GetReadingsResponse> {
    constructor() {
        super("viam.common.v1.GetReadingsResponse", [
            { no: 1, name: "readings", kind: "map", K: 9 /*ScalarType.STRING*/, V: { kind: "message", T: () => Value } }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message viam.common.v1.GetReadingsResponse
 */
export const GetReadingsResponse = new GetReadingsResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class LogEntry$Type extends MessageType<LogEntry> {
    constructor() {
        super("viam.common.v1.LogEntry", [
            { no: 1, name: "host", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "level", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "time", kind: "message", T: () => Timestamp },
            { no: 4, name: "logger_name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 5, name: "message", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 6, name: "caller", kind: "message", T: () => Struct },
            { no: 7, name: "stack", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 8, name: "fields", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => Struct }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message viam.common.v1.LogEntry
 */
export const LogEntry = new LogEntry$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AudioInfo$Type extends MessageType<AudioInfo> {
    constructor() {
        super("viam.common.v1.AudioInfo", [
            { no: 1, name: "codec", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "sample_rate_hz", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 3, name: "num_channels", kind: "scalar", T: 5 /*ScalarType.INT32*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message viam.common.v1.AudioInfo
 */
export const AudioInfo = new AudioInfo$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetPropertiesRequest$Type extends MessageType<GetPropertiesRequest> {
    constructor() {
        super("viam.common.v1.GetPropertiesRequest", [
            { no: 1, name: "name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 99, name: "extra", kind: "message", T: () => Struct }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message viam.common.v1.GetPropertiesRequest
 */
export const GetPropertiesRequest = new GetPropertiesRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetPropertiesResponse$Type extends MessageType<GetPropertiesResponse> {
    constructor() {
        super("viam.common.v1.GetPropertiesResponse", [
            { no: 1, name: "supported_codecs", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "sample_rate_hz", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 3, name: "num_channels", kind: "scalar", T: 5 /*ScalarType.INT32*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message viam.common.v1.GetPropertiesResponse
 */
export const GetPropertiesResponse = new GetPropertiesResponse$Type();
